// =============================
// Imports
// =============================

import { required } from '../index';

// =============================
// Validator
// =============================

const validator = {
  name: required,
};

export default validator;
